// extracted by mini-css-extract-plugin
module.exports = {"accountNavButton":"yt","menuBackground":"yu","navArrow":"yv","avatar":"yw","userName":"yx","active":"yy","b":"yz","a":"yA"};